// extracted by mini-css-extract-plugin
export default {"logo":"sidebar_logo__9GTRH","sidebarWrapper":"sidebar_sidebarWrapper__K7X8q","sidebarList":"sidebar_sidebarList__7FgQR"};